import { InjectionToken } from '@angular/core';

export const ZENDESK_ACCESS_TOKEN_KEY = new InjectionToken<string>('ZendeskAccessTokenKey');

export const ZENDESK_OAUTH_SCOPES = new InjectionToken<string>('ZendeskOauthScopes');
